import { useState, forwardRef, ForwardedRef, useImperativeHandle } from "react";
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { ToastRef } from "./interfaces";

interface IProps { };

const ToastMessage = forwardRef((props: IProps, ref: ForwardedRef<ToastRef>) => {
  const [show, setShow] = useState(false);
  const [variant, setVariant] = useState<'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light' | string>();
  const [content, setContent] = useState(false);

  useImperativeHandle(ref, () => ({
    showMessage(data: any) {
      setVariant(data.variant);
      setContent(data.content);
      setShow(true);
    }
  }));

  return (
    <ToastContainer className="p-3" position={'bottom-center'}>
      <Toast bg={variant} onClose={() => setShow(false)} show={show} delay={3000} autohide>
        <Toast.Body>{content}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
});

export default ToastMessage;